/**
 * Created by MateuszWaligora on 14.07.2017.
 */
/* eslint-disable */

import Vue from 'vue';
import querystring from 'querystring';
import moment from "moment/moment";


/**
 * @module Store/view
 * @description Module for statistics
 */

/**
 * @constant State of statistics store
 * @type {object}
 * */
const state = {
    date: [],
    statisticsShops: [],
    all: undefined,
    //Change it as it's an example
    kibanaLocation: `${process.env.VUE_APP_STATISTICS_URL}`,
    conversionData: []
};


/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getDateRange: state => {
        return state.date;
    },
    getStatisticsShops: state => {
        return state.statisticsShops;
    },
    getAll: state => {
        return state.all;
    },
    getConversionData: state => {
      return state.conversionData;
    },
    getKibanaLocation: state => {
      return state.kibanaLocation;
    }
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    updateDate: (state, payload) => {
      state.date = payload;
    },
    updateShops: (state, payload) => {
      state.shops = payload;
    },
    updateAll: (state, payload) => {
      state.all = payload;
    },
    updateConversionData: (state, payload) => {
      state.conversionData = payload;
    },
    updateKibanaLocation: (state, payload) => {
      state.kibanaLocation = payload;
    }
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    changeDate: ({ commit }, date) => {
      commit('updateDate', date);
    },
    changeShops: ({ commit }, shops) => {
      commit('updateShops', shops);
    },
    changeAll: ({ commit }, all) => {
      commit('updateAll', all);
    },
    async PostKibanaSettings({commit, state}, {token, showAll}) {
        let contexts;

        if (showAll) {
            contexts = this.state.shops.filtredShops.map((shop) => shop.setupID)
        } else {
            contexts = state.shops
        }
        const data = {
            from: Date.parse(moment(
                state.date[0] || moment().subtract(1, 'days')).format()) / 1000,
            to: Date.parse(moment(state.date[1] || moment()).format()) / 1000,
            step: 'hour'
        };
        const searchParams = querystring.stringify(data);
        commit('updateKibanaLocation', `${process.env.VUE_APP_STATISTICS_URL}?${searchParams}`);
        setTimeout(() =>
                window.frames['myFrame'].contentWindow.postMessage({contexts: contexts}, '*'),
            2500)
    },
    async getConversionData ({ commit }, { date, showAll, shops }){
      const body = {
        context: shops,
        date: {
            from: date[0],
            to: date[1]
        }
        //stage: 1
      };

      const { data } = await Vue.axios.post('/statistics/status', body);

      const { results } = data;


      if(results.length === 0){
        return {
          message: 'No data to show'
        }
      }
      if(data.error){
        throw data;
      }
      commit('updateConversionData', data);

      return results;
    }
};


export default {
    state,
    getters,
    mutations,
    actions
};
